import React, { lazy } from 'react';
import { Map } from 'lucide-react';
interface EmbeddedMapProps {
  destinationLat: number | null;
  destinationLng: number | null;
  className?: string;
}
export function EmbeddedMap({
  destinationLat,
  destinationLng,
  className = ''
}: EmbeddedMapProps) {
  const hasCoords = destinationLat && destinationLng;
  if (!hasCoords) {
    return <div className={`w-full h-56 rounded-2xl bg-[#1A1A1A] border border-white/10 flex items-center justify-center ${className}`} data-id="element-2265" data-mp="3hru1ek0l32zj">
        <div className="text-center" data-id="element-2266" data-mp="3qtthna3ry31f">
          <Map className="w-10 h-10 text-white/15 mx-auto mb-2" data-id="element-2267" data-mp="3qss8xca8dsmv" />
          <p className="text-white/30 text-sm" data-id="element-2268" data-mp="3vmcv872goy68">Mapa no disponible</p>
        </div>
      </div>;
  }
  const embedUrl = `https://www.google.com/maps?q=${destinationLat},${destinationLng}&z=15&output=embed`;
  return <div className={`w-full h-56 rounded-2xl overflow-hidden border border-white/10 bg-[#1A1A1A] ${className}`} data-id="element-2269" data-mp="9foet5fm0fxq">
      <iframe key={`${destinationLat}-${destinationLng}`} src={embedUrl} className="w-full h-full" loading="lazy" allowFullScreen referrerPolicy="no-referrer-when-downgrade" title="Mapa de destino" data-id="element-2270" data-mp="eb3snxdmabu5" />
    </div>;
}